/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AgentChatDeleteRequest {
    getFixupPrototypeFunction() { return AgentChatDeleteRequest.fixupPrototype; }

    static newInstance(model: Partial<AgentChatDeleteRequest>): AgentChatDeleteRequest {
        let obj = Object.assign(new AgentChatDeleteRequest(), model);
        AgentChatDeleteRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AgentChatDeleteRequest>): AgentChatDeleteRequest {
        if (!model) return null;
        return AgentChatDeleteRequest.newInstance(<AgentChatDeleteRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AgentChatDeleteRequest) {
        if (!obj) return;

        models.AgentChatDeleteRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AgentChatDeleteRequest): boolean {
        Object.setPrototypeOf(obj, AgentChatDeleteRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * List of chat IDs to be deleted
     */
    chat_ids: Array<string>;

    /**
     * ID of the tenant
     */
    tenant_id: string;

}
